// extracted by mini-css-extract-plugin
export var headerCell = "_5z-1";
export var loadingSpinnerContainer = "_5z-4";
export var loadingStateCell = "_5z-5";
export var rowWrapper = "_5z-3";
export var standaloneTable = "_5z-6";
export var table = "_5z-0";
export var white = "_5z-2";